import DoughnutChart from "../../../components/Doughnut.vue";
import AdminPageDataTable from "../../../components/AdminPageDataTable.vue";import api from "./api.js"
export default {
    components: {
        DoughnutChart, AdminPageDataTable
    },
    data: () => ({addDialog:false,fields: [{
        email: '',
        password1: '',
        password2: '',
    }],
        apiLink: "api/web/admin/get-admin-admins",
        apiSaveLink: "api/web/admin/save", apiDeleteLink: "api/web/admin/delete",
        slots: [{ title: 'item.email', header: 'email', type: 'text', col: 'email' }],
        switchSlots: [],
        headers: [

            { text: 'Id', value: 'id' },
            { text: 'Email', value: 'email' },
            { text: 'Actions', value: 'actions' },
        ],
      
    }),
    mounted() {
    },
    methods: {
        saveRows() {
            if (!this.$refs.form.validate()) {
                return
            }
            else {
                this.$store.state.loading = true;
                const records = [];
                this.fields.forEach(element => {
                    records.push(Object.values(element))
                });
                api.batchAddRows(records).then((res) => {
                    if (res.data.responseCode === 1) {
                        this.fetch(false)
                        this.fetchStat();
                        this.$store.state.loading = false;

                    }
                    this.fields = [{
                        email: '',
                        password1: '',
                        password2: '',
                    }];
                    this.addDialog = false;
                });
            }
        },
        addRow() {
            this.fields.push({
                email: '',
                password1: '',
                password2: '',
            });
        },
        removeRow(index) {
            this.fields.splice(index, 1);

        },
    },

};